import {
    GET_USER_BY_EMAIL
} from '../../api/apiEndpoints';

import {
    EDIT_UPDATE, EDIT_UPDATE_FAILED, EDIT_UPDATE_SUCCESS,
    LOGIN_USER_FAILED, USER_GET_AVATAR, USER_GET_AVATAR_FAILED, USER_GET_AVATAR_SUCCESS,
    USER_POINTS_UPDATE,
    USER_POINTS_UPDATE_FAIL,
    USER_POINTS_UPDATE_SUCCESS,

    USER_UPDATE,
    USER_UPDATE_FAILED,
    USER_UPDATE_SUCCESS
} from './types';
import patch from "../../api/methods/patch";
import { PATCH_USER_INFORMATION, GET_POINTS_BY_EMAIL } from "../../api/userEndpoints";
import {getUserAvatar} from "../../api/methods/user/getUserAvatar";

export const userPointsUpdate = (email, authToken) => (dispatch) => new Promise(function (resolve, reject) {
    dispatch({type: USER_POINTS_UPDATE});

    fetch(GET_POINTS_BY_EMAIL(email.trim()), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': authToken
        }
    })
        .then(response => {
            if (response.status !== 200) {
                throw (response);
            }
            return response.json();
        })
        .then(responseJson => {
            // console.log('update user points', responseJson);
            userPointsUpdateSuccess(dispatch, responseJson.data);
            resolve(100);
        })
        .catch(error => {
            // console.log('update user points', error);
            userPointsUpdateFailed(dispatch, 'Erro ao atualizar pontuação do usuário');
            reject(error);
        })

});

const userPointsUpdateFailed = (dispatch, message) => {
    dispatch({
        type: USER_POINTS_UPDATE_FAIL
    });
};

const userPointsUpdateSuccess = (dispatch, newPoints) => {
    dispatch({
        type: USER_POINTS_UPDATE_SUCCESS,
        payload: newPoints
    });
};

export const userUpdate = (userEmail, authToken) => {
    return (dispatch) => {
        dispatch({ type: USER_UPDATE });

        fetch(GET_USER_BY_EMAIL(userEmail), {
            method: 'GET',
            headers: {
                'Authorization': authToken
            }
        })
            .then(response => {
                if (response.status !== 200) throw (response);
                return response.json();
            })
            .then(responseJson => {
                dispatch({
                    type: USER_UPDATE_SUCCESS,
                    payload: responseJson.data
                })
            })
            .catch(error => console.log(error));
    };
};

export const refreshUserAvatar = (userEmail, authToken) => {
    return async (dispatch) => {

        dispatch({
            type: USER_GET_AVATAR
        });

        try {

            let result = await getUserAvatar(userEmail, authToken);
            console.log(result);

            dispatch({
                type: USER_GET_AVATAR_SUCCESS,
                payload: result
            })

        } catch (e) {
            console.log(e);
            dispatch({ type: USER_GET_AVATAR_FAILED });
            throw e;
        }

    }
};

export const updateUserAsync = (userId, userName, userNickname, userAvatar, authToken) => {
    return async (dispatch) => {
        dispatch({ type: EDIT_UPDATE });

        const payload = {
            userId: userId,
            userName: userName,
            userNickname: userNickname,
            avatarImage: userAvatar,
        };

        try {

            let updateResult = await patch(PATCH_USER_INFORMATION, payload, authToken);

            dispatch({
                type: EDIT_UPDATE_SUCCESS,
                payload: {
                    userName: userName,
                    userNickname: userNickname,
                }
            });

            return updateResult;

        } catch (e) {
            console.log(e);

            dispatch({
                type: EDIT_UPDATE_FAILED,
                payload: {
                    error: e
                }
            });

            throw e;
        }
    }
};
